var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [(_vm.closeTrip == false) ? _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("DEPS-Start Trip (LM)")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Create Trip"
    },
    on: {
      "click": _vm.showStartTrip
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Trip ID :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.parentObj.tmstripid))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Trip Status :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.parentObj.tripstatus))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("BA/SR :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.parentObj.srUser))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v("Vehicle Number :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.parentObj.vehicleNumber))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n          Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n          Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tempshow),
      expression: "tempshow"
    }],
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "damage",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Damage/ Pilferage")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "z-index": "3"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isDamageLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isDamageLoader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "6%"
    }
  }, [_vm._v("MPS")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "margin-right": "65%"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MPS),
      expression: "MPS"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "MPS",
      "id": "MPS"
    },
    domProps: {
      "value": (_vm.MPS)
    },
    on: {
      "keyup": _vm.validateMPS,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.MPS = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.mpsError))])], 1), _vm._v(" "), _c('th', [_vm._v("DEPS Type")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DEPSType),
      expression: "DEPSType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "Damage",
      "value": "Damage",
      "name": "DEPSType"
    },
    domProps: {
      "checked": _vm._q(_vm.DEPSType, "Damage")
    },
    on: {
      "__c": function($event) {
        _vm.DEPSType = "Damage"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Damage"
    }
  }, [_vm._v("Damage ")]), _vm._v("     \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DEPSType),
      expression: "DEPSType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "Pilferage",
      "value": "Pilferage",
      "name": "DEPSType"
    },
    domProps: {
      "checked": _vm._q(_vm.DEPSType, "Pilferage")
    },
    on: {
      "__c": function($event) {
        _vm.DEPSType = "Pilferage"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Pilferage"
    }
  }, [_vm._v("Pilferage")]), _vm._v("     \n                  ")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.depsTypeErr))])], 1), _vm._v(" "), _c('th', [_vm._v("Upload Image")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('label', {
    attrs: {
      "for": "files"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "font-size": "15px",
      "color": "black",
      "cursor": "pointer"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload($event)
      }
    }
  })]), _vm._v(" "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "multiple",
      "id": "files",
      "name": "Image"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload($event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.imageerr))])], 1), _vm._v(" "), _c('th', [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "margin-left": "35%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveMPSDamgeOrPilferage
    }
  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Scanned MPS Details")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('label', [_c('b', [_vm._v("MPS: " + _vm._s(_vm.MPS))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('label', [_c('b', [_vm._v("AWB: " + _vm._s(_vm.AWB))])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("DEPS MPS List")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showTable) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', [_vm._v("MPS")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("DEPS Type")]), _vm._v(" "), _c('th', [_vm._v("Loaded in Vehicle")]), _vm._v(" "), _c('th', [_vm._v("Images")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.damageMPS), function(data) {
    return _c('tr', {
      staticClass: "text-primary"
    }, [_c('td', [_vm._v(_vm._s(data.mps))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.depstype))]), _vm._v(" "), (data.loadinvehicle) ? _c('td', [_vm._v("Y")]) : _vm._e(), _vm._v(" "), (!data.loadinvehicle) ? _c('td', [_vm._v("N")]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', [_c('div', {
      staticClass: "row"
    }, _vm._l((data.imagearr), function(image) {
      return _c('div', {
        staticClass: "col-md-3"
      }, [_c('img', {
        staticStyle: {
          "width": "35px",
          "height": "35px",
          "cursor": "pointer"
        },
        attrs: {
          "src": image,
          "alt": "NO Image",
          "title": "Open Image"
        },
        on: {
          "click": function($event) {
            _vm.openImage(image)
          }
        }
      }), _vm._v(" "), _c('section', [_c('img', {
        staticStyle: {
          "width": "100%",
          "max-width": "300px"
        },
        attrs: {
          "id": "myImg",
          "id": 'imgid' + image
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "modal",
        attrs: {
          "id": 'myModalImg' + image
        }
      }, [_c('span', {
        staticClass: "close",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "title": "close Image"
        },
        on: {
          "click": function($event) {
            _vm.closemodal('myModalImg' + image)
          }
        }
      }, [_vm._v("×")]), _vm._v(" "), _c('img', {
        staticClass: "modal-content1",
        attrs: {
          "id": 'img' + image,
          "src": image
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin": "auto",
          "display": "block",
          "width": "80%",
          "max-width": "700px",
          "text-align": "center",
          "color": "#ccc",
          "padding": "10px 0",
          "height": "150px"
        }
      })])])])
    }))])])])
  }))]) : _vm._e()]), _vm._v(" "), _c('br')])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shortage",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Shortage")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isShortageLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isShortageLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-tabs', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "content-class": "mt-2"
    }
  }, [_c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": "MPS Not scanned",
      "title-link-class": _vm.linkClass(0)
    },
    on: {
      "click": function($event) {
        _vm.changeShortageTab('NotScanned')
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("MPS")]), _vm._v(" "), _c('th', [_vm._v("AWB")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.notScannedMPS), function(data, index) {
    return _c('tr', {
      staticClass: "text-primary"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedNotScannedMPS),
        expression: "selectedNotScannedMPS"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.mps,
        "checked": Array.isArray(_vm.selectedNotScannedMPS) ? _vm._i(_vm.selectedNotScannedMPS, data.mps) > -1 : (_vm.selectedNotScannedMPS)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedNotScannedMPS,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.mps,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedNotScannedMPS = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedNotScannedMPS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedNotScannedMPS = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mps))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.selectedNotScannedMPS.length == 0
    },
    on: {
      "click": _vm.markShortSelectedMPS
    }
  }, [_vm._v("Mark Short")]), _vm._v("   \n              ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": 'MPS marked short(' + _vm.markShortMPS.length + ')',
      "title-link-class": _vm.linkClass(1)
    },
    on: {
      "click": function($event) {
        _vm.changeShortageTab('MarkShort')
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("MPS")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Remove From Shortage")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.markShortMPS), function(data, index) {
    return _c('tr', {
      staticClass: "text-primary"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mps))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data) ? _c('i', {
      staticClass: "fa fa-remove",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Remove from Shortage"
      },
      on: {
        "click": function($event) {
          _vm.selectRemove(data)
        }
      }
    }) : _vm._e()])])
  }))])]), _vm._v(" "), _c('br')])])], 1)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.closeTrip == true) ? _c('div', [_c('close-trip', {
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a977163c","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/depsStartTrip/depsStartTrip.component.html
// module id = 1350
// module chunks = 3